import type PlainDate from '@Domain/PlainDate';

const dayFormatter = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });

/**
 * The label of an audio: the interview it comes from, named after its kind and day. The single place
 * that builds it; an interview whose kind or date is unknown has been deleted.
 */
const resolveAudioLabel = (
	interviewKind: 'conversation' | 'notes' | null,
	date: PlainDate | null,
): string => {
	if (interviewKind === null || date === null) {
		return 'Entretien supprimé';
	}

	const day = dayFormatter.format(date.toCalendar());

	return interviewKind === 'notes' ? `Notes du ${day}` : `Entretien du ${day}`;
};

export default resolveAudioLabel;
